import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const InspectionFormAddMain = lazyLoader(
  () =>
    import(
      "Containers/Inspections/InspectionsFormsDashboard/InspectionFormAdd/InspectoinFormAddMain/InspectionFormAddMain"
    )
);

export const InspectionFormsCreate = () => {
  return (
    <Layout>
      <InspectionFormAddMain />
    </Layout>
  );
};
